// Web 端设备标识与端类型识别（F3 单会话控制）。
// deviceId：浏览器级稳定 UUID，存 localStorage；endType：桌面/平板(iPad)/手机浏览器。

const DEVICE_ID_KEY = 'swiftx_device_id';

export type WebEndType = 'WEB_DESKTOP' | 'WEB_TABLET' | 'WEB_MOBILE';

/** 获取（或首次生成并持久化）当前浏览器的 deviceId */
export const getOrCreateDeviceId = (): string => {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
};

/**
 * 识别当前 Web 端类型。
 * iPad 坑：iPadOS 13+ Safari 默认以「桌面版 UA」上报为 Macintosh，
 * 用 platform=Mac && maxTouchPoints>1 的 heuristic 辅助判定为平板。
 */
export const getEndType = (): WebEndType => {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  const maxTouch = typeof navigator !== 'undefined' ? navigator.maxTouchPoints || 0 : 0;

  // iPad（含伪装成 Mac 的 iPadOS Safari）
  const isIPad = /iPad/.test(ua) || (/Macintosh/.test(ua) && maxTouch > 1);
  if (isIPad) return 'WEB_TABLET';

  // 手机浏览器
  if (/iPhone|iPod|Windows Phone/.test(ua) || /Android.*Mobile/.test(ua)) {
    return 'WEB_MOBILE';
  }

  // 非 Mobile 的 Android 视为平板
  if (/Android/.test(ua)) return 'WEB_TABLET';

  // 其余视为桌面浏览器
  return 'WEB_DESKTOP';
};
